import React from "react";

interface HealthBarProps {
  currentHealth: number;
  maxHealth: number;
  enemyName: string;
  rarity: string;
}

const HealthBar: React.FC<HealthBarProps> = ({
  currentHealth,
  maxHealth,
  enemyName,
  rarity,
}) => {
  const healthPercentage = (currentHealth / maxHealth) * 100;

  const getRarityColor = (rarity: string) => {
    switch (rarity) {
      case "common":
        return "#9ca3af";
      case "rare":
        return "#3b82f6";
      case "epic":
        return "#8b5cf6";
      case "legendary":
        return "#f59e0b";
      default:
        return "#9ca3af";
    }
  };

  const getHealthColor = (percentage: number) => {
    if (percentage > 60) return "#10b981"; // green
    if (percentage > 30) return "#f59e0b"; // yellow
    return "#ef4444"; // red
  };

  return (
    <div className="health-bar-container">
      <div className="enemy-info">
        <h3 className="enemy-name" style={{ color: getRarityColor(rarity) }}>
          {enemyName}
        </h3>
        <div className="health-text">
          {currentHealth} / {maxHealth} HP
        </div>
      </div>
      <div className="health-bar-wrapper">
        <div className="health-bar-background">
          <div
            className="health-bar-fill"
            style={{
              width: `${healthPercentage}%`,
              backgroundColor: getHealthColor(healthPercentage),
            }}
          />
        </div>
        <div className="health-percentage">{Math.round(healthPercentage)}%</div>
      </div>
    </div>
  );
};

export default HealthBar;
